import React from 'react';
import { gridConnectionsRoute } from '@/modules/charge-center/grid-connections/route';
import { createRoute, redirect } from '@tanstack/react-router';

export const gridConnectionsIndexRoute = createRoute({
  getParentRoute: () => gridConnectionsRoute,
  path: '/',
  component: React.lazy(async () => await import('@/app/routes/ChargeCenter/All')),
  wrapInSuspense: true,
  beforeLoad: ({ location }) => {
    if (location.pathname === '/charge-center/grid-connections') {
      // * Redirect to charge points only if no specific grid connection is selected
      return redirect({
        to: '/charge-center/grid-connections/charge-points',
        search: (prev: Record<string, unknown>) => prev,
      });
    }
  },
});
